// removed by extract-text-webpack-plugin
module.exports = {"DrawerToggle":"DrawerToggle__DrawerToggle__2OjR2"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/SideDrawer/DrawerToggle/DrawerToggle.css
// module id = 101
// module chunks = 0